// @flow

import { locationsUrl, locationsPersonalisedSuggestUrl } from 'src/config';
import { createUnauthenticatedHttpClient } from 'src/modules/seek-api-request';

type LocationSuggestQuery = {
  source: string,
  country: Locale,
  q: string,
  correctDistance: number,
  limit: number
};

type LocationPersonalisedSuggestQuery = {
  country: Locale,
  recentLocation: string
};

const suggest = (query: LocationSuggestQuery) =>
  createUnauthenticatedHttpClient()
    .send({
      label: 'locations',
      url: locationsUrl,
      timeout: 3000, // Avg 1100, so use minimum of 3000
      params: query
    })
    .then(({ data: suggestions }) => {
      if (suggestions.international.length === 0) {
        return [
          {
            suggestions: suggestions.local
          }
        ];
      }

      if (suggestions.local.length === 0) {
        return [
          {
            suggestions: suggestions.international
          }
        ];
      }

      return [
        {
          suggestions: suggestions.local
        },
        {
          sectionName: 'INTERNATIONAL',
          suggestions: suggestions.international
        }
      ];
    });

const personalisedSuggest = (query: LocationPersonalisedSuggestQuery) =>
  createUnauthenticatedHttpClient()
    .send({
      url: locationsPersonalisedSuggestUrl,
      label: 'locations-personalised-suggest',
      timeout: 3000, // Avg 1300, so use minimum of 3000
      params: query
    })
    .then(response => response.data);

export default {
  suggest,
  personalisedSuggest
};
